import React, { Component } from 'react';
import { Modal, Steps, Button, message, Select } from 'antd';
import axios from 'axios';
import Configuration from '../../Configuration';
const Step = Steps.Step;
const Option = Select.Option;

class WarehouseModal extends Component {
  constructor(props) {
    super(props);
    this.headers = {Authorization: localStorage.getItem('visitapp:token')};
    this.validationSteps = {step0: {name: false, branch: false}};
    this.state = {step: 0, stepLimit: 0, warehouse: {}, branches: [], validations: this.validationSteps};
    this.handleNext = this.handleNext.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.showStep = this.showStep.bind(this);
    // Input values
    this.handleName = this.handleName.bind(this);
    this.handleBranch = this.handleBranch.bind(this);
    this.setProp = this.setProp.bind(this);
    this.setValidation = this.setValidation.bind(this);
    this.validateStep = this.validateStep.bind(this);
    this.getBranches = this.getBranches(this);
  }

  handleNext() {
    if(this.validateStep(this.state.step))
      return message.warning('Necesitas llenar los campos obligatorios')

    if(this.state.step === this.state.stepLimit) {
      this.props.handleSave(this.state.warehouse);
      this.setState({validations: this.validationSteps, warehouse: {}});
    } else {
      this.setState({step: this.state.step + 1});
    }
  }

  handleBack() {
    if(this.state.step === 0) {
      this.setState({validations: this.validationSteps});
      this.props.handleClose();
    } else {
      this.setState({step: this.state.step - 1});
    }
  }

  handleName(event) {
    this.setProp('name', event.target.value);
    this.setValidation('name', 0);
  }

  handleBranch(value) {
    this.setProp('branch_id', value);
    this.setValidation('branch', 0);
  }

  setValidation(prop, step) {
    const validation = this.state.validations;
    validation[`step${step}`][prop] = true;

    this.setState({validations: validation});
  }

  validateStep(step) {
    let counter = 0;

    const steps = this.state.validations;
    for(let validation in steps[`step${step}`]) {
      if(steps[`step${step}`][validation] === false) {
        counter += 1;
      }
    }

    if(counter === 0) {
      return false;
    } else {
      return true;
    }
  }

  setProp(prop, value) {
    const record = this.state.warehouse;
    record[prop] = value;

    this.setState({warehouse: record});
  }

  showStep(step) {
    if(step === this.state.step) {
      return 'block';
    } else {
      return 'none';
    }
  }

  getBranches() {
    axios.get(`${Configuration.apiServer}/api/v1/branches`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.setState({branches: resp.data});
    });
  }

  render() {
    // Get branches when is open
    if(this.state.visible) {
      this.getBranches();
    }

    // Options for branch select
    const branchOptions = this.state.branches.map(branch => {
      return (
        <Option value={branch.id} className="text-capitalize" key={branch.id}>{branch.name}</Option>
      );
    });

    // Render component
    return (
      <Modal
        title={this.props.title}
        visible={this.props.visible}
        onCancel={this.props.handleClose}
        width={800}
        footer={null}
        destroyOnClose={true}
      >
        <div className="row" style={{ padding: '0px 30px' }}>
          <Steps size="small" current={this.state.step}>
            <Step title="Nombre" />
            <Step title="Finalizar" />
          </Steps>
        </div>

        <br/> <br/>

        <div className="row" style={{ padding: '0px 30px' }}>
          <div style={{ width: '100%', display: this.showStep(0) }}>
            <div className="form-group">
              <label>Nombre</label>
              <input type="text" className="form-control" defaultValue={this.props.current.name} placeholder="Nombre de almacén" onChange={this.handleName} />
            </div>

            <div className="form-group">
              <label>Sucursal</label>
              <Select
                showSearch
                style={{ width: '100%' }}
                placeholder="Elige una sucursal"
                optionFilterProp="children"
                onChange={this.handleBranch}
                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              >
                {branchOptions}
              </Select>
            </div>
          </div>
        </div>

        <br/><hr/>

        <div className="form-group text-center">
          <Button type="dashed" style={{ marginRight: '10px' }} onClick={this.handleBack}>Atras</Button>
          <Button type="primary" onClick={this.handleNext}>Siguiente</Button>
        </div>
      </Modal>
    );
  }
}

export default WarehouseModal;



// WEBPACK FOOTER //
// ./src/components/modals/WarehouseModal.js